import React from "react"
import List from "../List"
import { Root } from "../Common/Root"

const ListPage = (props) => {
  return (
    <Root>
      <List {...props} />
    </Root>
  )
}
export default ListPage
